'use strict';

wbApp.filter('wbHumanNameSort', ['gridSortSvc',
    function (gridSortSvc) {
        return function (items, field, reverse) {
            return _.orderBy(
                items, 
                [function(o) { return gridSortSvc.sortHumanFullName2(o, field); }], 
                [reverse ? 'desc' : 'asc']);
        }
    }]);